import React from "react";
import { Skeleton } from "@mui/material";
import ScrollCardStyles from "../homepage/horizontalScrollCard/ScrollableCard.module.css";

const HomePageSkeleton = ({audio}) => {
  const skeletonStyles = {
    backgroundColor: "white",
    color: "white", // Set the text color to white
  };
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <div className={`w-full`} key={index}>
          <div className="my-4">
            <Skeleton
              width={100}
              sx={{ ...skeletonStyles, display: "inline-block" }}
              className={`${ScrollCardStyles.title} text-2xl`}
            />
            {
              !audio && (
                <Skeleton
                width={50}
                sx={{ ...skeletonStyles, display: "inline-block" }}
                className={`float-right my-auto text-2xl`}
              />
              ) 
            }
          </div>
          <div className={`${ScrollCardStyles.imageContainer} my-4 mx-0`}>
            {Array.from({ length: 5 }).map((_, index) => (
              <div
                className={`${index === 4 ? "" : "mr-4"} ${
                  ScrollCardStyles.scrollableImage
                }`}
                key={index}
              >
                <Skeleton
                  variant="rectangular"
                  width={"40vw"}
                  height={"40vw"}
                  sx={skeletonStyles}
                  className="rounded-lg"
                />
                <Skeleton
                  variant="text"
                  width={90}
                  sx={{ fontSize: "1rem", ...skeletonStyles, marginTop: "10px" }}
                />
                <Skeleton
                  variant="text"
                  width={60}
                  sx={{ fontSize: "0.8rem", ...skeletonStyles, marginTop: "5px" }}
                  className="mt-3"
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default HomePageSkeleton;
